import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { AppPlanType } from 'src/app/core/types/app-plan.type';
import { TranslationService } from 'src/app/i18n';
import { PlanListItemForBuyDto } from '../../../../core/api/models';

@Component({
    selector: 'app-plans-type-module-card',
    templateUrl: './plans-type-module-card.component.html',
    styleUrls: ['./plans-type-module-card.component.scss'],
    standalone: false
})
export class PlansTypeModuleCardComponent implements OnInit {
  @Input() model: PlanListItemForBuyDto;
  @Input() vocabsPath: string;
  @Input() parentLoading: boolean;
  @Input() type: AppPlanType = 'module';
  buyButtonLoading: boolean;

  @Output() selectedPlanModulePrice = new EventEmitter<PlanListItemForBuyDto>();

  constructor(
    protected loggerService: LoggerService,
    public translationService: TranslationService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['parentLoading']) {
        const timeOut = setTimeout(() => {
          this.buyButtonLoading = false;
          clearTimeout(timeOut);
        }, 500);
      }
    } catch (error) {
      this.loggerService.logError(
        'app-plans-type-module-card',
        error,
        EventTypes.plans
      );
    }
  }

  onEmitSelectedPlanListItemPrice() {
    if (this.buyButtonLoading) return;
    if (this.type == 'module') this.buyButtonLoading = true;
    this.selectedPlanModulePrice.emit(this.model);
  }
}
